import { ApiRequest } from '@sancare/typescript-commons/src/misc/api-request'

import { DiagnosisState } from '@/store/modules/diagnosis/types'

const baseUrl = '/api/rhs/{rhsId}/diagnosis'

const state = new DiagnosisState()
state.requests = {
  addSmrDiagnosis: new ApiRequest('addSmrDiagnosis', 'POST', baseUrl),
  removeSmrDiagnosis: new ApiRequest('removeSmrDiagnosis', 'DELETE', `${baseUrl}/{associatedDiagnosisId}`),
  updateSmrDiagnosis: new ApiRequest('updateSmrDiagnosis', 'PUT', `${baseUrl}/{associatedDiagnosisId}`),
}

export { state }
